import { Search as SearchIcon } from '@mui/icons-material'
import { Box, InputAdornment, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface SettingsSearchbarProps {
  searchQuery: string
  onSearchChange: (value: string) => void
}

export const SettingsSearchbar = ({ searchQuery, onSearchChange }: SettingsSearchbarProps) => {
  const { t } = useTranslation('settings')

  return (
    <Box sx={{ p: 3 }}>
      <TextField
        fullWidth
        placeholder={t('search-placeholder')}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ width: 18, height: 18 }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}
